// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","logo":"Header_logo__3T0lc","logoNote":"Header_logoNote__RSyfY","mainNav":"Header_mainNav__1KfVX","github":"Header_github__1q8St"};